// @ts-check
import { initFinstralSlider } from "../../../js/utils/finstral-slider.js";

/**
 * @param {HTMLElement} host
 * @returns {() => void} teardown function
 */
export function initCarouselSlider(host) {
	return initFinstralSlider(host, {
		trackSelector: ".js-CarouselSlider-track",
		slideSelector: ".js-CarouselSlider-slide",
		buttonPreviousSelector: ".js-CarouselSlider-navigationButton--previous",
		buttonNextSelector: ".js-CarouselSlider-navigationButton--next",
		navigationSelector: ".CarouselSlider-navigation",
		navigationAnchorSelector:
			".CarouselSliderSlide-media, .CarouselSliderSlide-mediaWrapper",
	});
}
